import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Maximize2, X } from "lucide-react";

export const Skin3D_Preview = ({ skin_name, rvmode, className = "" }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Construct the iframe URL
  const iframe_url = skin_name && rvmode
    ? `https://skins3d.dnaracing.run/?rvmode=${encodeURIComponent(rvmode)}&skin=${encodeURIComponent(skin_name)}`
    : null;

  const handleFullscreen = () => {
    setIsFullscreen(true);
  };

  const closeFullscreen = () => {
    setIsFullscreen(false);
  };

  // Fullscreen overlay modal
  const fullscreenModal = isFullscreen && iframe_url ? (
    <div className="fixed inset-0 z-[100] backdrop-blur-md bg-black/70">
      {/* Close Button - Top Right */}
      <div className="absolute top-6 right-6 z-[200]">
        <button
          onClick={closeFullscreen}
          className="w-10 h-10 rounded-full bg-black/30 backdrop-blur-sm border border-white/20 flex items-center justify-center text-white hover:bg-black/50 transition-colors duration-200"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Modal Content - Centered */}
      <div className="w-full h-full flex items-center justify-center p-4">
        <div className="w-full max-w-7xl">
          {/* Maintain aspect ratio */}
          <div className="aspect-[1166/656] w-full rounded-xl overflow-hidden shadow-2xl">
            <iframe
              src={iframe_url}
              className="w-full h-full border-0"
              title={`3D Preview Fullscreen - ${skin_name}`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            />
          </div>

          {/* Skin info below */}
          <div className="mt-4 text-center">
            <h3 className="text-white text-xl font-digi">
              {skin_name} ({rvmode})
            </h3>
          </div>
        </div>
      </div>
    </div>
  ) : null;

  return (
    <>
      <div className={`w-full h-full rounded-lg overflow-hidden relative group ${className}`}>
        {iframe_url ? (
          <>
            <iframe
              src={iframe_url}
              className="w-full h-full border-0"
              title={`3D Preview - ${skin_name}`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            />

            {/* Fullscreen button - top right */}
            <button
              onClick={handleFullscreen}
              className="absolute top-2 right-2 w-8 h-8 rounded-lg bg-black/60 backdrop-blur-sm border border-white/20 flex items-center justify-center text-white hover:bg-black/80 transition-all duration-200 opacity-30 group-hover:opacity-100 z-10"
              title="Fullscreen"
            >
              <Maximize2 className="w-4 h-4" />
            </button>
          </>
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-slate-600/40 to-slate-800/60 flex flex-col items-center justify-center rounded-lg border-2 border-dashed border-slate-500/50 p-4">
            <div className="text-4xl sm:text-5xl md:text-6xl mb-3 sm:mb-4">🎮</div>
            <div className="text-white font-medium text-base sm:text-lg mb-2">
              3D Model View
            </div>
            <div className="text-gray-400 text-xs sm:text-sm text-center max-w-xs px-4">
              No preview available
            </div>
          </div>
        )}
      </div>

      {/* Render fullscreen modal in portal */}
      {fullscreenModal && createPortal(fullscreenModal, document.body)}
    </>
  );
};
